function CyclingIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.5 7C22.6046 7 23.5 6.10457 23.5 5C23.5 3.89543 22.6046 3 21.5 3C20.3954 3 19.5 3.89543 19.5 5C19.5 6.10457 20.3954 7 21.5 7ZM21.5 9C23.7091 9 25.5 7.20914 25.5 5C25.5 2.79086 23.7091 1 21.5 1C19.2909 1 17.5 2.79086 17.5 5C17.5 7.20914 19.2909 9 21.5 9Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26 30C28.4853 30 30.5 27.9853 30.5 25.5C30.5 23.0147 28.4853 21 26 21C23.5147 21 21.5 23.0147 21.5 25.5C21.5 27.9853 23.5147 30 26 30ZM26 32C29.5899 32 32.5 29.0899 32.5 25.5C32.5 21.9101 29.5899 19 26 19C22.4101 19 19.5 21.9101 19.5 25.5C19.5 29.0899 22.4101 32 26 32Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 30C9.48528 30 11.5 27.9853 11.5 25.5C11.5 23.0147 9.48528 21 7 21C4.51472 21 2.5 23.0147 2.5 25.5C2.5 27.9853 4.51472 30 7 30ZM7 32C10.5899 32 13.5 29.0899 13.5 25.5C13.5 21.9101 10.5899 19 7 19C3.41015 19 0.5 21.9101 0.5 25.5C0.5 29.0899 3.41015 32 7 32Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.6396 7.00692C15.9191 7.03996 16.1717 7.18922 16.3355 7.41808L21.9474 15.2609H26.5C27.0523 15.2609 27.5 15.7086 27.5 16.2609C27.5 16.8132 27.0523 17.2609 26.5 17.2609H21.4333C21.1107 17.2609 20.8079 17.1052 20.6201 16.8428L15.3479 9.4748L9.10043 14.8923L16.9592 20.6727C17.2154 20.8612 17.3667 21.1602 17.3667 21.4783V28C17.3667 28.5523 16.919 29 16.3667 29C15.8144 29 15.3667 28.5523 15.3667 28V21.9841L6.90749 15.7621C6.66264 15.582 6.51299 15.3003 6.50081 14.9966C6.48862 14.6929 6.61523 14.4001 6.84486 14.201L14.8671 7.2445C15.0797 7.06013 15.3602 6.97388 15.6396 7.00692Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.1546 11.7556L11.6546 18.2556L10.3447 16.7443L17.8447 10.2443L19.1546 11.7556Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default CyclingIcon;
